<div class="modal-overlay" *ngIf="isVisible" (click)="cerrarModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Términos y Condiciones</h2>
      <button class="modal-close-btn" (click)="cerrarModal()" aria-label="Cerrar">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <!-- Usar el componente de términos y condiciones existente -->
      <app-terminos-condiciones></app-terminos-condiciones>
    </div>

    <div class="modal-footer">
      <button class="btn-cerrar" (click)="cerrarModal()">Cerrar</button>
      <button class="btn-aceptar" (click)="aceptarTerminos()">Aceptar</button>
    </div>
  </div>
</div>
